module.exports = __webpack_public_path__ + "media/images/form-3670a6afe2f0c6bf61c9281821469f3d.png";